<template>
   <div>
    <span class="text-black mb-2 md:text-5xl text-4xl">Take action to
 <span class="font-black text-dark">improve your life</span></span>
    <p class="onboarding-paragraph text-dark">
      Focus on the things that matter and become
    the designer of your best life.
    </p>
<!--     <p class="onboarding-paragraph text-dark">
      Stay efficiently and consistently organized
with your new life companion.
    </p> -->
    <p class="onboarding-paragraph text-dark font-bold">
      It's all in your hands.
    </p>
  </div>
</template>
<script>

export default {
  props: {
  },
  data () {
    return {
    }
  }
}
</script>
